<template>
    <section id="project_five_content">

        <div class="row" id="first_row">

            <!-- In Small Screen -->
            <h3 class="mt-4 mb-0 d-block d-lg-none">منصة مشروعي</h3>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                    <h3 class="d-none d-lg-block">منصة مشروعي</h3>

                    <p>المنصة الشريكة لمنصة WRO العالمية لإدارة واستثمار مشاريع التخرج الجامعية والمسابقات الإبتكارية
                        وتحويلها إلى فرص استثمارية بدراسات ذات جدوى لبدء رحلة رواد الأعمال والمبتكرين بطريقة سهلة ومؤتمنة.
                    </p>

                    <h5 class="mt-3">مهمتنا في منصة مشروعي</h5>

                    <p>دراسة جدوى لعدد من المشاريع المربحة وفيها يتم توضيح اوضاع السوق وكيفية المنافسة والمتطلبات من حيث
                        الموقع والمساحة والتجهيزات وكذلك يتم توضيح الامور المالية مثل التكاليف المتوقعة واسعار البيع
                        والايرادات وصافي الارباح المتوقعة وغيرها من الامور الهامة لأصحاب المشاريع الصغيرة.</p>

                    <h5 class="mt-3">ماذا نقدم لك؟</h5>

                    <ul class="mb-lg-0">
                        <li>تكامل قنوات الأعمال</li>
                        <li>تمويل للمشاريع</li>
                        <li>الاستشارات والشهادات</li>
                        <li>خدمات الإستيراد والتصدير</li>
                    </ul>

                </div>

            </div>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                <div class="col_two_content">
                    <div class="img_wrapper">
                        <img src="@/assets/images/projects/project_five_img.webp" alt="">
                    </div>
                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'ProjectFive',
}
</script>

<style lang="scss" scoped>
#project_five_content {

    #first_row {

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 18px;
            line-height: 180%;
        }

        .col_one_content {

            p {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                text-align: justify;
                margin-bottom: 0;
            }

            h5 {
                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Green;
            }

            h5:nth-of-type(2n) {
                color: $Yellow;
            }

            ul {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                padding-right: 15px;
                padding-left: 0px;
                text-align: justify;

                li::marker {
                    color: $Yellow;
                }
            }

        }

        // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
        .col_two_content {

            position: relative;

            width: 636px;
            height: 426px;

            @include breakpoints(x-small) {
                width: 351px;
                height: 235px;
            }

            @include breakpoints(small) {
                width: 516px;
                height: 345px;
            }

            @include breakpoints(medium) {
                width: 696px;
                height: 466px;
            }

            @include breakpoints(large) {
                width: 456px;
                height: 305px;
            }

            @include breakpoints(x-Large) {
                width: 546px;
                height: 366px;
            }

            background: $Green;
            box-sizing: border-box;

            // https://www.cssportal.com/css-clip-path-generator/
            // CSS Vendor Prefixes
            -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

            .img_wrapper {

                position: absolute;
                top: 1px;
                left: 1px;

                width: 634px;
                height: 424px;

                @include breakpoints(x-small) {
                    width: 349px;
                    height: 233px;
                }

                @include breakpoints(small) {
                    width: 514px;
                    height: 343px;
                }

                @include breakpoints(medium) {
                    width: 694px;
                    height: 464px;
                }

                @include breakpoints(large) {
                    width: 454px;
                    height: 303px;
                }

                @include breakpoints(x-Large) {
                    width: 544px;
                    height: 364px;
                }

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                // border: solid 2px $Green;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    opacity: 0.9;
                }

                img:hover {
                    opacity: 1;
                    -webkit-transition: opacity 0.5s linear 0.2s;
                    -moz-transition: opacity 0.5s linear 0.2s;
                    transition: opacity 0.5s linear 0.2s;
                }

            }

        }

    }

}
</style>